// CX Table — auto inject <colgroup> for 2-col key/value tables
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cx-table').forEach(table => {
    // 이미 colgroup이 있으면 스킵
    if (table.querySelector('colgroup')) return;

    // 첫 번째 실제 행의 셀 수가 2개일 때만 주입 (key/value 테이블 보호)
    const firstRow = table.querySelector('thead tr, tbody tr');
    if (!firstRow) return;
    const cells = firstRow.querySelectorAll('th, td');
    if (cells.length !== 2) return;

    const colgroup = document.createElement('colgroup');
    const colKey = document.createElement('col');
    colKey.className = 'col-key';
    const colVal = document.createElement('col');
    colVal.className = 'col-val';
    colgroup.appendChild(colKey);
    colgroup.appendChild(colVal);
    table.insertBefore(colgroup, table.firstChild);
  });
});
